import React, { Component } from 'react';
import './App.scss';
import Close from './components/Close.js';
import IntroductionPage from './pages/IntroductionPage.js';
import QuestionPage from './pages/QuestionPage.js';

import ResultPage from './pages/ResultPage.js';

import lacapiProxy from './libs/lacapi';
import ExplorerPage from './pages/explorerPage';

class App extends Component {
	state = {
		isLoggedIn: false,
		courseId: 6574, //default to that for dev
		questions: [],
		user: { hasResult: false },
		started: false,
		loaded: false,
		//userAverage: null,
		average: null,
		amount: null,
		courseTitle: null
	};

	setStarted = (started) => {
		this.setState({ started });
	}

	restart = () => {
		this.setState({ started: false, user: { ...this.state.user, hasResult: false } });
		window.scrollTo(0, 0);
	}

	componentWillMount() {
		window.scrollTo(0, 0);
		this.setState({ isIE: !!window.MSInputMethodContext && !!document.documentMode });

		lacapiProxy.init().then((data) => {
			console.log("lacapiProxy.init");
			if (lacapiProxy.getURLParameter("courseid")) {
				var cid = parseInt(lacapiProxy.getURLParameter("courseid"));
				if (!isNaN(cid)) {
					this.setState({ courseId: cid });
				}
			}

			lacapiProxy.isLoggedIn().then((result) => {
				if (result) {
					this.setState({ isLoggedIn: true });
					this.afterLogin();
				}
				else {
					if (window.location.href.indexOf("localhost") == -1) {
						window.location.href = "/";
					} else {
						lacapiProxy.login("elev@madrs.luvit.se", "123456").then((result) => {
							result && this.afterLogin();
						});
					}
				}
			});
		});
	}

	afterLogin() {
		lacapiProxy.getCurrentUserInfo().then((userInfo) => {
			this.setState({ user: userInfo });
			lacapiProxy.setCourseSession(this.state.courseId).then((courseData) => {
				lacapiProxy.getDocuments().then((docList) => {
					docList.forEach(doc => {
						if (doc.typeid == 301) {
							this.setState({ courseTitle: doc.title });
							lacapiProxy.StartTestAndFetchQuestionDetails(doc.id).then(response => {
								lacapiProxy.getUserResults(this.state.user.id, this.state.courseId).then(data => {
									console.log(data);
									/*
									const userAverage = data.answers
										.map(answer => answer.answerId)
										.reduce((acc, currentValue) => acc + currentValue);
*/
									this.setState({ amountPeople: data.crowdAverage.amount });
									//this.setState({ userAverage });
									this.setState({ average: data.crowdAverage.average });

									this.setState({ user: { ...this.state.user, hasResult: data.answers.length > 0, results: data } });

									console.log("user:", this.state.user);
									data.answers.forEach(uAnswer => {
										var question = response.itemDetails.filter((item) => { return item.id === uAnswer.questionId })[0];
										question.chosenAnswerIndex = uAnswer.answerId;
										question.chosenAnswer = question.answers[uAnswer.answerId].id;
										question.otherAnswers = uAnswer.otherAnswers;
									});

									this.setState({ questions: response.itemDetails });
									this.setState({ loaded: true });
								});
							});
						}
						else if (doc.typeid == 26) {
							fetch(doc.url).then(introHtml => {
							});
						}
					});
				});
			});
		});
	}

	render() {
		return (
			<div>

					<Close />
					{
						this.state.isIE ? <ExplorerPage /> : (
							this.state.user.hasResult) ?
							<ResultPage {...this.state} restart={this.restart} /> : (
								this.state.started ?
									<QuestionPage {...this.state} setStarted={this.setStarted} /> :
									<IntroductionPage {...this.state} setStarted={this.setStarted} />
							)
					}
			</div>
		);
	}
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js